import { PaletteMode } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { grey as MuiGrey } from '@mui/material/colors';


const defaultTheme = createTheme();
const createColor = (mainColor: string) => defaultTheme.palette.augmentColor({ color: { main: mainColor } });

const grey = {
  ...MuiGrey,
  100: '#F6F6F6',
  // 900: '#121212',
};

const primary = '#143986';
const secondary = '#eeb52f';
const primaryAltBase = '#ef992a';

const palette = (mode: PaletteMode) => {
  return {
    mode,
    grey,
    primary: {
      main: primary,
      contrastText: '#fff',
    },
    primaryAlt: createColor(primaryAltBase),
    buttonWhite: createColor('#ffffff'),
    secondary: {
      main: secondary,
      contrastText: '#1D2330',
    },
    warning: {
      main: '#ee9d2b',
    },
    text: {
      secondary: '#626d84',
    },
    success: {
      main: '#2eb873',
    },
    background: {
      default: mode === 'light' ? 'white' : grey['900'],
    },
  };
};

export default palette;


declare module '@mui/material/styles' {
  interface Palette {
    primaryAlt: Palette['primary'];
    buttonWhite: Palette['primary'];
  }

  interface PaletteOptions {
    primaryAlt?: PaletteOptions['primary'];
    buttonWhite?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    primaryAlt: true;
    buttonWhite: true;
  }
}
